import { riskCheckType, } from '../models';
export const isRiskCheckTinCheck = (check) => check.type === riskCheckType.Enum.tin;
export const isRiskCheckGovCheck = (check) => check.type === riskCheckType.Enum.gov;
export const isRiskCheckWatchlist = (check) => check.type === riskCheckType.Enum.watchlist;
